// Web-specific setup
// Ovdje možemo dodati sve web-specific konfiguracije i polyfillove

// Dummy export da TypeScript ne bi bacao grešku
export default {};
